import { Box, Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import AError from "../components/a-error";

const ErrorPage = ({ errorMessage }: { errorMessage: string | undefined }) => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      sx={{
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Grid size={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            width: "100%",
          }}
        >
          <AError errorMessage={errorMessage ?? t("somethingWentWrong")} />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
